export const AuthStorage = {
  USER_KEY: 'user_data',
  
  getToken: () => null,
  setToken: (token) => {},
  removeToken: () => {},
  
  getUser: () => {
    try {
      return JSON.parse(localStorage.getItem('user_data'));
    } catch { return null; }
  },
  setUser: (user) => localStorage.setItem('user_data', JSON.stringify(user)),
  removeUser: () => localStorage.removeItem('user_data'),
  
  isLoggedIn: () => !!localStorage.getItem('user_data'),
  clearUser: () => localStorage.removeItem('user_data')
};

export const StorageService = {
  saveMetrics: (domain, data) => {
    const key = `metrics_${domain}`;
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    existing.push({ 
      ...data, 
      timestamp: Date.now(),
      id: `${Date.now()}_${Math.random()}`
    });
    const limited = existing.slice(-100);
    localStorage.setItem(key, JSON.stringify(limited));
  },
  
  getMetrics: (domain, days = 30) => {
    const key = `metrics_${domain}`;
    const data = JSON.parse(localStorage.getItem(key) || '[]');
    const cutoff = Date.now() - (days * 24 * 60 * 60 * 1000);
    return data.filter(d => d.timestamp >= cutoff);
  },
  
  getAllDomains: () => {
    const domains = new Set();
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.startsWith('metrics_')) {
        domains.add(key.replace('metrics_', ''));
      }
    }
    return Array.from(domains);
  },
  
  deleteDomain: (domain) => {
    const key = `metrics_${domain}`;
    localStorage.removeItem(key);
  },
  
  clearAll: () => {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.startsWith('metrics_')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  },
  
  exportData: (domain) => {
    const data = StorageService.getMetrics(domain, 365);
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${domain}_metrics_${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
};

export const ConsentStorage = {
  CONSENT_KEY: 'cv-consent',
  
  getConsent: () => {
    try {
      return JSON.parse(localStorage.getItem('cv-consent'));
    } catch { return null; }
  },
  
  setConsent: (consent) => {
    localStorage.setItem('cv-consent', JSON.stringify({
      ...consent,
      timestamp: Date.now()
    }));
  },
  
  hasConsent: () => {
    const consent = ConsentStorage.getConsent();
    return consent && consent.essential;
  },
  
  clearConsent: () => {
    localStorage.removeItem('cv-consent');
    window.dispatchEvent(new CustomEvent('consent-reopened'));
  }
};

export const AnimationStorage = {
  SETTINGS_KEY: 'animationSettings',
  
  getSettings: () => {
    try {
      return JSON.parse(localStorage.getItem('animationSettings'));
    } catch { return null; }
  },
  
  setSettings: (settings) => {
    localStorage.setItem('animationSettings', JSON.stringify(settings));
    if (window.animationSettings) {
      Object.assign(window.animationSettings, settings);
    }
  }
};

export default { AuthStorage, StorageService, ConsentStorage, AnimationStorage };
